<template>
  <el-container class="main-container">
    <el-header>
      <head_page :head_page_type=false ref="head_page"></head_page>
    </el-header>

    <el-main>
      <div id='choose_city'>
          <head_menu :has-back=true @go-back-click="backToCity" :has-next=true @go-next-click="goNext" :disableNext="disableNext">
            <template #title>
              <div style="text-align:center;background-color: #F0F0EE;color:#53ADBC;padding:5px;font-size: 20px;">
                {{chosen_city_shown}}<span style="font-size:16px;color:grey">{{version}}</span>
              </div>
            </template>
          </head_menu>
        <div class="hidden-sm-and-down" style="margin-top: 0; padding-top:5px" >
          <div v-loading="loading" v-bind:element-loading-text="$t('message.Desperately_loading')"
            element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
            <!--
            <div style="text-align: left;">
              <el-row>
                <el-col :span="8" style="background-color: #F0F0EE;">
                  <el-button-group>
                    <el-button icon="el-icon-d-arrow-left" @click="backToCity" style="background-color: #f3f3f4;"></el-button>
                    <el-button icon="el-icon-s-home" @click="goHome" style="background-color: #e9e9ea;"></el-button>
                    <el-button icon="el-icon-d-arrow-right" @click="goNext" style="background-color: #f3f3f4;"></el-button>
                  </el-button-group>
                </el-col>
                <el-col :span="6" style="text-align:center;background-color: #F0F0EE;color:#53ADBC;padding:10px;font-size: 20px;">
                  {{chosen_city_shown}}<span style="font-size:16px;color:grey">{{version}}</span>
                </el-col>
                <el-col :span="10" style="text-align: right;background-color: #F0F0EE;">
                </el-col>
              </el-row>
            </div>
            -->
            <div v-if = "$route.query.chosen_city=='Nanjing'" style="background-color: #F6F6F6; margin:20px 20px 0 20px; paddin:10px 0">
              <div v-if = "$i18n.locale=='en'">
                <p style="color:sienna; text-align: left; font-size:20px;">April 1, 2025</p>
                <p style="text-align: left">Data results using Modeling V1.2 & China Telecom data until <a style="color:sienna;">April 1,2025</a>, then enhanced Modeling V2.1 & China Unicom Data after this date.</p>
              </div>
              <div v-if = "$i18n.locale=='cn'">
                <p style="color:sienna; text-align: left; font-size:20px;">4月1日, 2025</p>
                <p style="text-align: left"><a style="color:sienna;">2025年4月1日</a>后，后续时间使用2025版中国联通数据最新数据</p>
              </div>
            </div>
            <div v-if = "$route.query.chosen_city=='Wuhan'" style="background-color: #F6F6F6; margin:20px 20px 0 20px; paddin:10px 0">
              <div v-if = "$i18n.locale=='en'">
                <p style="color:sienna; text-align: left; font-size:20px;">Aug 28, 2023</p>
                <p style="text-align: left">Data results using Modeling V1.2 & China Telecom data until <a style="color:sienna;">Aug 28,2023</a>, then enhanced Modeling V2.1 & China Unicom Data after this date.</p>
              </div>
              <div v-if = "$i18n.locale=='cn'">
                <p style="color:sienna; text-align: left; font-size:20px;">8月28日, 2023</p>
                <p style="text-align: left">数据使用V1.2模型和中国电信数据直至<a style="color:sienna;">2023年8月28日</a>，后续时间使用增强版V2.1模型和中国联通数据</p>
              </div>
            </div>
            <div v-if = "$route.query.chosen_city=='Chongqing'" style="background-color: #F6F6F6; margin:20px 20px 0 20px; paddin:10px 0">
              <div v-if = "$i18n.locale=='en'">
                <p style="text-align: left">Propsal after<a style="color:sienna;">Aug 1,2024</a>will use v2 data</p>
              </div>
              <div v-if = "$i18n.locale=='cn'">
                <p style="text-align: left">方案日期在<a style="color:sienna;">2026年3月1日</a>之后，将使用使用新版数据</p>
              </div>
            </div>
            <div v-if = "$route.query.chosen_city=='Shenzhen'" style="background-color: #F6F6F6; margin:20px 20px 0 20px; paddin:10px 0">
              <div v-if = "$i18n.locale=='en'">
                <p style="text-align: left">Propsal after<a style="color:sienna;">Nov 1,2024</a>will use v2 data</p>
              </div>
              <div v-if = "$i18n.locale=='cn'">
                <p style="text-align: left">方案日期在<a style="color:sienna;">2024年11月1日</a>之后，将使用使用新版数据</p>
              </div>
            </div>
            <div v-if = "$route.query.chosen_city=='Chengdu'" style="background-color: #F6F6F6; margin:20px 20px 0 20px; paddin:10px 0">
              <div v-if = "$i18n.locale=='en'">
                <p style="text-align: left">Propsal after<a style="color:sienna;">Aug 1,2024</a>will use v2 data</p>
              </div>
              <div v-if = "$i18n.locale=='cn'">
                <p style="text-align: left">方案日期在<a style="color:sienna;">2024年8月1日</a>之后，将使用使用新版数据</p>
              </div>
            </div>
            <div style="background-color: #F6F6F6; margin:20px 20px 0 20px; paddin:10px 0">
              <el-row style="" :gutter="20">
                <el-col :span="14" style="text-align: left;" >
                  <el-row style="margin:10px;height:40px">
                    <el-col :span="7" style="text-align: right;">
                      <span style="font-size: 16px;color:#254A6E;font-weight: 600; vertical-align: sub;">{{$t('message.Campaign_Starting_Date')}}</span>
                    </el-col>
                    <el-col :span="16" :offset="1">
                      <el-date-picker style="width:150px;margin-right: 20px;" v-model="value_date" type="date" size="small"
                        value-format="timestamp" placeholder="Date">
                      </el-date-picker>
                    </el-col>
                  </el-row>
                  <el-row style="margin:10px;height:40px">
                    <el-col :span="7" style="text-align: right;">
                      <span style="font-size: 16px;color:#254A6E;font-weight: 600; vertical-align: sub;">{{$t('message.Duration')}}</span>
                    </el-col>
                    <el-col :span="16" :offset="1">
                      <el-select v-model="value_duration" :placeholder="$t('message.Select')" style="width:100px" size="small">
                        <el-option v-for="item in options_duration" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                      <span style="font-size: 16px; margin-left: 10px;">{{$t('message.Months')}}</span>
                    </el-col>
                  </el-row>
                  <el-row v-if="show_vendor_box_city.includes($route.query.chosen_city)" style="margin:10px;height:40px">
                    <el-col :span="7" style="text-align: right;">
                      <span style="font-size: 16px;color:#254A6E;font-weight: 600; vertical-align: sub;">{{$t('message.vendor')}}</span>
                    </el-col>
                    <el-col :span="16" :offset="1">
                      <el-select v-model="value_vendor" :placeholder="$t('message.Select')" style="width:100px" size="small" multiple>
                        <el-option v-for="item in vendor_options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                  
                  
                  <el-row style="margin:10px;height:40px">
                    <el-col :span="7" style="text-align: right;">
                      <span style="font-size: 16px;color:#254A6E;font-weight: 600; vertical-align: sub;">{{$t('message.Select_Media_Format')}}</span>
                    </el-col>
                    <el-col :span="16" :offset="1">
                      <el-checkbox-group v-model="value_media_format" @change="handlechecked">
                        <el-checkbox-button v-for="(a,b) in media_format_options" :label="a.value"
                          :key="b">
                          <span v-if="$i18n.locale == 'en'">{{a.label}}</span>
                          <span v-if="$i18n.locale == 'cn'">{{a.label_cn}}</span>
                        </el-checkbox-button>
                      </el-checkbox-group>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="10">
                  <p style="margin-top: 40px">
                    <span style="vertical-align:middle; font-size: 18px;color:#254A6E;font-weight:600">{{$t('message.Estimated_Potential_Audience')}}</span>
                    <el-popover placement="top-start" width="300" trigger="hover" >
                      <div>
                      　<span>{{$t('message.Viewed_impression_Upgraded_metric')}}</span><br/>
                      　<span>{{$t('message.Viewed_impression_reflects_the_number_of_people')}}</span><br/>
                      　<span>{{$t('message.This_methodology_includes_complex_viewability_factors_already_used_internationally_by_the_OOH_industry')}}</span>
                      </div>
                      <el-button icon="el-icon-info" circle slot="reference" style="border:0px; background-color: #F6F6F6;"></el-button>
                    </el-popover>
                  </p>
                  <p>
                    <span style="margin-right:20px;font-size: 18px;color:#53ADBC">{{estimated_audience.toLocaleString()}}</span>
                  </p>
                </el-col>
              </el-row>
            </div>
            <!--
            <div style="background-color: #F6F6F6;">
              <div style="margin-top: 20px;" >
                <el-row :gutter="20">
                  <el-col :span="12">
                    <div style="background-color: white;margin:10px;height:40px">
                      <div style="padding: 5px;">
                        <span style="font-size: 18px;color:#254A6E;font-weight: 600;">{{$t('message.Campaign_Starting_Date')}}</span>
                        <el-date-picker style="width:150px;margin-right: 20px;" v-model="value_date" type="date" size="small"
                          value-format="timestamp" placeholder="Date">
                        </el-date-picker>
                        <span style="font-size: 18px;color:#254A6E;font-weight: 600;">{{$t('message.Duration')}}</span>
                        <el-select v-model="value_duration" :placeholder="$t('message.Select')" style="width:100px" size="small">
                          <el-option v-for="item in options_duration" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                        <span>&nbsp;{{$t('message.Months')}}</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div style="background-color: white;margin:10px;height:40px;text-align: center;">
                      <span style="margin:20px;font-size: 18px;color:#254A6E;font-weight:600">{{$t('message.Estimated_Potential_Audience')}}</span>
                      <el-popover placement="top-start" width="300" trigger="hover" >
                        <div>
                        　<span>{{$t('message.Viewed_impression_Upgraded_metric')}}</span><br/>
                        　<span>{{$t('message.Viewed_impression_reflects_the_number_of_people')}}</span><br/>
                        　<span>{{$t('message.This_methodology_includes_complex_viewability_factors_already_used_internationally_by_the_OOH_industry')}}</span>
                        </div>
                        <el-button icon="el-icon-info" circle slot="reference" style="border:0px"></el-button>
                      </el-popover>
                      <span style="margin:20px;font-size: 18px;color:#53ADBC">{{estimated_audience.toLocaleString()}}</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" style="margin-top:20px ;margin-left:10px ;margin-bottom:20px ;font-size: 20px;color:#254A6E;font-weight:600; background-color: white;">
                    <div style="background-color: white;height:40px;text-align: center;">
                      {{$t('message.Select_Media_Format')}}
                    </div>
                  </el-col>
                  
                  <el-col :span="8">
                    <div style="margin-top:20px ;margin-bottom:20px ;background-color: white;height:40px;text-align: center;">
                      <el-checkbox-group v-model="value_media_format" @change="handlechecked">
                        <el-checkbox-button v-for="(a,b) in media_format_options" :label="a.value"
                          :key="b">
                          <span v-if = "$i18n.locale == 'en'">{{a.label}}</span>
                          <span v-if = "$i18n.locale == 'cn'">{{a.label_cn}}</span>
                        </el-checkbox-button>
                      </el-checkbox-group>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
            -->

          </div>
          <div id='choose_city' style="margin-top:0px; padding-top:15px"
            v-loading="loading" v-bind:element-loading-text="$t('message.Desperately_loading')"
            element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-row :gutter ="20">
              <el-col :span="19" style="padding:20px">
                <div class="grid-content bg-grey">
                  <div style= "font-size: 20px;color:#254A6E;font-weight:600;padding-top: 10px">
                    {{$t('message.CampaignByPerformanceCriterias')}}
                  </div>
                  <el-row :gutter="20" style="margin-top: 20px;font-size: 20px;color:#53ADBC;font-weight:600;">
                    <el-col :span="12">
                      {{$t('message.ByAudience')}}
                      <el-popover placement="top-start" trigger="hover">
                        <pre v-if = "$i18n.locale=='en'">
    Audience based campaign :

    Result will automatically provide bus lines by their best performance index according to chosen criterias

    Note : 
    - target profile & audience interests can be combined together
    - Interst is unique choice

                        </pre>
                        <pre v-if = "$i18n.locale=='cn'">
    基于受众的广告投放：

    结果将根据选择的标准以最佳性能指标自动提供巴士线路

    注意 ：
    -目标资料和受众兴趣可以结合在一起
    -兴趣是唯一的选择
                        </pre>
                        
                        <el-button icon="el-icon-info" circle slot="reference" style="border:0px;background-color:#F6F6F6;"></el-button>
                      </el-popover>
                      <el-row>
                        <el-col :span="12" style="border-color: #8CC5FF;border-top-width: 1px;border-buttom-width: 1px;border-left-width: 1px;border-right-width: 0px;border-style: solid;">
                          <div style="background-color: white;margin:10px;height:480px;text-align: center;">
                            <span class="title-3" style="margin:20px;color:#254A6E;font-weight:600">{{$t('message.Audience')}}</span>
                            <div style="margin: 30px;">
                              <div>
                                <p style="text-align: left;color:#254A6E "><strong>{{ $t('message.Gender') }}</strong></p>
                              </div>
                              <div style="text-align: left; margin-bottom: 20px;">
                                <el-select v-if ="$i18n.locale=='en'" v-model="value_gender" clearable :placeholder="$t('message.Select')" :disabled="disable_poi_audience">
                                  <el-option v-for="item in gender_options" :key="item.value" :label="item.label" :value="item.value">
                                  </el-option>
                                </el-select>
                                <el-select v-if ="$i18n.locale=='cn'" v-model="value_gender" clearable :placeholder="$t('message.Select')" :disabled="disable_poi_audience">
                                  <el-option v-for="item in gender_options" :key="item.value" :label="item.label_cn" :value="item.value">
                                  </el-option>
                                </el-select>
                              </div>
                              <div>
                                <p style="text-align: left; color:#254A6E"><strong>{{ $t('message.Age') }}</strong></p>
                              </div>
                              <div style="text-align: left; margin-bottom: 20px;">
                                <el-select v-if ="$i18n.locale=='en'" v-model="value_age" multiple :placeholder="$t('message.Select')" :disabled="disable_poi_audience"
                                  @change="checkBoxValueAge">
                                  <el-option v-for="item in age_options" :key="item.value" :label="item.label" :value="item.value">
                                  </el-option>
                                </el-select>
                                <el-select v-if ="$i18n.locale=='cn'" v-model="value_age" multiple :placeholder="$t('message.Select')" :disabled="disable_poi_audience"
                                  @change="checkBoxValueAge">
                                  <el-option v-for="item in age_options" :key="item.value" :label="item.label_cn" :value="item.value">
                                  </el-option>
                                </el-select>
                              </div>
                              <div>
                                <p style="text-align: left;color:#254A6E "><strong>{{ $t('message.Spend_Power') }}</strong></p>
                              </div>
                              <div style="text-align: left; ">
                                <el-select v-if ="$i18n.locale=='en'" v-model="value_spend_power" multiple :placeholder="$t('message.Select')" :disabled="disable_poi_audience"
                                  @change="checkBoxValueSpendPower">
                                  <el-option v-for="item in display_spend_power_options" :key="item.value" :label="item.label" :value="item.value">
                                  </el-option>
                                </el-select>
                                <el-select v-if ="$i18n.locale=='cn'" v-model="value_spend_power" multiple :placeholder="$t('message.Select')" :disabled="disable_poi_audience"
                                  @change="checkBoxValueSpendPower">
                                  <el-option v-for="item in display_spend_power_options" :key="item.value" :label="item.label_cn" :value="item.value">
                                  </el-option>
                                </el-select>
                              </div>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="12" style="border-color: #8CC5FF;border-top-width: 1px;border-buttom-width: 1px;border-left-width: 0px;border-right-width: 1px;border-style: solid;">
                          <div style="background-color: white;margin:10px;height:480px;text-align: center;">
                            <span class="title-3" style="margin:20px;color:#254A6E;font-weight:600">{{$t('message.Interests')}}</span>
                            <el-checkbox-group v-if = "$i18n.locale == 'en'" style="text-align: left; margin-top:10px;" v-model="value_interest_temp" :disabled="disable_poi_audience" @change="handlecheckedInterest">
                              <el-checkbox style="width:100%;margin:0px;margin:0.5em;" v-for="item in interest_options" :key="item.value" :label="item.value" :value="item.value">
                                {{item.label}}
                              </el-checkbox>
                            </el-checkbox-group>
                            <el-checkbox-group v-if = "$i18n.locale == 'cn'" style="text-align: left; margin-top:10px;" v-model="value_interest_temp" :disabled="disable_poi_audience" @change="handlecheckedInterest">
                              <el-checkbox style="width:100%;margin:0px;margin:0.5em;" v-for="item in interest_options" :key="item.value" :label="item.value" :value="item.value">
                                {{item.label_cn}}
                              </el-checkbox>
                            </el-checkbox-group>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="12">
                      {{$t('message.ByPointsOfInterest')}}
                      <el-popover placement="top" trigger="hover">
                        <div>
                          <pre v-if = "$i18n.locale=='en'">
    POI based campaign :

    Result will automatically provide best performing Bus lines index according to geolocated points of Interests.

    Either by:
    categories (POI Types)
    Location (where they are)

    Eg : The more museums on your route : best line will see more museums…

    Note : 2 types of POI:
    1- Point if Interests is Strict : we apply a 200m radius
    (eg : for an university : the GPS point in the center of it)

    2- An Area Zone (can include several GPS point – An average zone will be calculated (Radius Max of 500 M)

                          </pre>
                          <pre v-if = "$i18n.locale=='cn'">
    基于POI的广告系列：

    结果将根据地理位置的兴趣点自动提供性能最佳的公交线路索引。

    或者通过：
    类别（POI类型）
    位置（所在位置）

    例如：您路线上的博物馆越多：最好的路线会看到更多博物馆…

    注意：2种POI：
    1-如果兴趣点是精确地点 ：我们用200m半径
    （例如：对于大学：位于其中心的GPS点）

    2-范围区域（可以包含多个GPS点-将计算平均区域（半径最大值为500 M）
                          </pre>
                          
                        </div>
                        <el-button icon="el-icon-info" circle slot="reference" style="border:0px;background-color:#F6F6F6;"></el-button>
                      </el-popover>
                      <el-row>
                        <el-col :span="12" style="border-color: #8CC5FF;border-top-width: 1px;border-buttom-width: 1px;border-left-width: 1px;border-right-width: 0px;border-style: solid;">
                          <div style="background-color: white;margin:10px;height:480px;text-align: center;">
                            <span class="title-3" style="color:#254A6E;font-weight:600">{{$t('message.POIType')}}</span>
                              <el-popover placement="top" trigger="hover">
                        <div>
                          <pre v-if = "$i18n.locale=='en'">
    Based on Gaode map data​
    Categorize the POI around the route and perform a quantitative analysis by category. The more POIs in the selected category, the higher the corresponding score.​
    The classification is divided into four categories: business, entertainment, life, and tourism.​
    When multiple selections are made, compare the total amount of multiple indicators.​
    The point of interest type is the quantitative analysis dimension of POI.
                          </pre>
                          <pre v-if = "$i18n.locale=='cn'">
    以高德地图数据为基础数据​
    对线路周边POI进行归类，按类别进行定量分析，选定的类别POI数量越多，则相应的评分越高。​
    归类分为四大类别：商务、娱乐、生活、旅游四类。​
    当多选时，比较多种指标的量的总数。​
    兴趣点类型为POI 的定量分析维度。
                          </pre>
                          
                        </div>
                        <el-button icon="el-icon-info" circle slot="reference" style="border:0px;"></el-button>
                      </el-popover>
                            <div style="margin:10px">
                              <div style="font-size:30px;text-align: left;">
                                <el-checkbox v-model="checked_business" :disabled="disable_poi_audience" style="width: 100%">{{ $t('message.BUSINESS') }}</el-checkbox>
                                <p style="font-size:10px; text-align: left;color:#606266;font-weight: 500;">
                                  {{ $t('message.Business_Center') }} /{{ $t('message.Industrial_Park') }} / {{ $t('message.Government') }}
                                </p>
                              </div>
                      
                              <div style="font-size:30px;text-align: left;">
                                <el-checkbox v-model="checked_entertainment" :disabled="disable_poi_audience" style="width: 100%">{{ $t('message.ENTERTAINEMENT') }}</el-checkbox>
                                <p style="font-size:10px; text-align: left;color:#606266;font-weight: 500;">
                                  {{ $t('message.Sports') }} /{{ $t('message.Entertainment') }} / {{ $t('message.Culture') }}
                                </p>
                              </div>
                              <div style="font-size:30px;text-align: left;">
                                <el-checkbox v-model="checked_living" :disabled="disable_poi_audience" style="width: 100%">{{ $t('message.LIVING') }}</el-checkbox>
                                <p style="font-size:10px; text-align: left;color:#606266;font-weight: 500;">
                                  {{ $t('message.Shopping') }} /{{ $t('message.Residental_Area') }} /
                                  <br/>
                                  {{ $t('message.School_University') }} / {{ $t('message.Hospital') }}
                                </p>
                              </div>
                              <div style="font-size:30px;text-align: left;">
                                <el-checkbox v-model="checked_trip" :disabled="disable_poi_audience" style="width: 100%">{{ $t('message.TRIP') }}</el-checkbox>
                                <p style="font-size:10px; text-align: left;color:#606266;font-weight: 500;">
                                  {{ $t('message.Tourist_Attractions') }} / {{ $t('message.Transportation_Hub') }} / {{ $t('message.Art_Museum') }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="12" style="border-color: #8CC5FF;border-top-width: 1px;border-buttom-width: 1px;border-left-width: 0px;border-right-width: 1px;border-style: solid;">
                          <div style="background-color: white;margin:10px;height:480px;text-align: center;">
                            <span class="title-3" style="margin:10px;color:#254A6E;font-weight:600">{{$t('message.POILocation')}}
              <el-popover placement="top" trigger="hover">
                        <div>
                          <pre v-if = "$i18n.locale=='en'">
    106 AOI points in 24 business districts (Wuhan)​
    96 AOI points in 18 business districts  (Nanjing)​
    Route search for designated business districts/AOI points​
    Accurate to a specific business district/point is a qualitative analysis dimension​
    You can select up to 6 business districts/AOI at the same time​
    When selecting at the same time, the search relationship is "and"​

    When searching, first take 300m of the AOI point as the radius,
    If you can’t find any routes, search again with a radius of 500m.
    If there is still no data, search again with a radius of 1000m until the route information is found and output.
    If the route information has been searched in the previous step, the search for the next radius will not be performed.
    Directly output data based on the current radius.
                          </pre>
                          <pre v-if = "$i18n.locale=='cn'">
    24个商圈 106个AOI点位（武汉）​
    18个商圈 96个AOI点位（南京）​
    指定商圈/AOI点位的线路搜索​
    精确到特定的商圈/点位，是定性的分析维度​
    最多可以同时选择6个商圈/AOI​
    同时选择时搜索关系为“且”​

    搜索时 ，先以AOI点的300m为半径，
    若搜索不到任何线路，则以500m为半径重新搜索，
    若仍无数据则以1000m为半径重新搜索直到搜索到线路信息并输出。
    若前面步骤已经搜索得到线路信息将不会进行下一个半径的搜索，
    直接输出以当前半径为基础的数据。
                          </pre>
                        </div>
                        <el-button icon="el-icon-info" circle slot="reference" style="border:0px"></el-button>
                      </el-popover>
                            </span>
                            <p style="margin:20px;font-size: 20px;color:#254A6E;font-weight:600">{{$t('message.Nearby_Location')}}</p>
                            <div style="margin:20px;">
                              <el-select v-model="poi_ba_selection_list" filterable multiple :multiple-limit="6" :placeholder="$t('message.Select')">
                                <el-option
                                v-for="item in poi_ba_options"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="{value:item.value,label:item.label}">
                                </el-option>
                              </el-select>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                      
                      
                    </el-col>
                  </el-row>
                  
                  
                </div>
              </el-col>
              <el-col :span="5" style="padding:20px 20px 0 20px;">
                <div class="grid-content bg-grey" style="padding-bottom: 13px">
                  <div style= "font-size: 20px;color:#254A6E;font-weight:600; padding-top:38px;">
                    <p>{{$t('message.RegularRateCard')}}</p>
                    <el-row>
                      <div style="height:20px">
                      </div>
                    </el-row>
                  </div>
                  <div style="background-color: white;margin:20px 20px 0 20px;height:480px;text-align: center;">
                    <span class="title-3" style="margin:10px;color:#254A6E;font-weight:600">{{$t('message.Rank')}}
                      <el-popover placement="top-start" width="200" trigger="hover">
                        <div>
                          <span>{{$t('message.LegacyFixedSystem')}}</span>
                        </div>
                        <el-button icon="el-icon-info" circle slot="reference" style="border:0px"></el-button>
                      </el-popover>
                    </span>
                    <el-checkbox-group v-model="value_rank" style="text-align: left;">
                      <el-checkbox v-for="item in rank_options" :label="item.value" :key="item.value" style="display:block;margin:30px;">
                        {{item.label}}
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="4">
              <div class="div_navi">
                <p class="p_navi_button" v-on:click="backToCity">
                  {{$t('message.Back')}}
                </p>
              </div>
            </el-col>
          
          
            <el-col :span="8">
              <div>
          
              </div>
            </el-col>
          
            <el-col :span="4">
              <div style="background-color: #909399;">
                <p :class="disableNext? 'p_navi_button_disabled':'p_navi_button'" v-on:click="goNext">
                  {{$t('message.Next')}}
                </p>
              </div>
            </el-col>
          </el-row>

          <el-row style="background-color: white;">
            <el-col :span="4" :offset="20">
            <div style="background-color: #909399;">
                <p :class="disableNext? 'p_navi_button_disabled':'p_navi_button'" v-if="create_package" v-on:click="goPackageSelection">
                  {{$t('message.Create_Package')}}
                </p>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="hidden-md-and-up" style="background-color: white;">
          <div :class="menuFixed == true ? 'isFixed' :''" style="margin-top: 0; padding-top:5px; background-color: rgb(246, 246, 246)"
            v-loading="loading" v-bind:element-loading-text="$t('message.Desperately_loading')">
            <el-row>
              <el-col :span=24 style="text-align: center;">
                <span style="vertical-align:middle; font-size: 12px;color:#254A6E;font-weight:600">{{$t('message.Estimated_Potential_Audience')}}</span>
                <el-popover placement="top-start" width="300" trigger="click" >
                  <div>
                  　<span>{{$t('message.Viewed_impression_Upgraded_metric')}}</span><br/>
                  　<span>{{$t('message.Viewed_impression_reflects_the_number_of_people')}}</span><br/>
                  　<span>{{$t('message.This_methodology_includes_complex_viewability_factors_already_used_internationally_by_the_OOH_industry')}}</span>
                  </div>
                  <el-button icon="el-icon-info" circle slot="reference" style="border:0px; background-color: #F6F6F6;"></el-button>
                </el-popover>
              </el-col>
              <el-col :span=24 style="text-align: center; margin-bottom: 10px;">
                <span style="font-size: 14px;color:#53ADBC">{{estimated_audience.toLocaleString()}}</span>
              </el-col>
            </el-row>
          </div>
          <div class="hidden-sm-and-up" v-if="menuFixed && $i18n.locale == 'cn'" style="padding-top:71px; background-color: white">
          </div>
          <div class="hidden-sm-and-up" v-if="menuFixed && $i18n.locale == 'en'" style="padding-top:95px; background-color: white">
          </div>

          <el-collapse accordion style="margin-top: 10px;"
            v-loading="loading" v-bind:element-loading-text="$t('message.Desperately_loading')">
            <el-collapse-item :title="$t('message.General')" ref="generalSection">
              <el-form ref="general_form" label-width="35%">
                <el-form-item :label="$t('message.Campaign_Starting_Date')">
                  <el-row style="text-align: left">
                    <el-date-picker style="width: 80%; margin: 5px 20px;" v-model="value_date" type="date" size="small"
                      value-format="timestamp" placeholder="Date">
                    </el-date-picker>
                  </el-row>
                </el-form-item>
                <el-form-item :label="$t('message.Duration')">
                  <el-row style="text-align: left">
                    <el-col :span=16>
                      <el-select v-model="value_duration" :placeholder="$t('message.Select')" size="small" style="width: 85%; margin-left: 20px; margin-top: 5px">
                        <el-option v-for="item in options_duration" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span=8 style=" margin-top: 5px">
                      <span style="font-size: 12px; margin-left: 3px;">{{$t('message.Months')}}</span>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item :label="$t('message.Select_Media_Format')">
                  <el-row style="text-align: left">
                    <el-checkbox-group v-model="value_media_format" @change="handlechecked" style="margin-left: 20px; margin-top: 5px">
                        <el-checkbox v-for="(a,b) in media_format_options" :label="a.value"
                          :key="b">
                          <p v-if="$i18n.locale == 'en'">{{a.label}}</p>
                          <p v-if="$i18n.locale == 'cn'">{{a.label_cn}}</p>
                        </el-checkbox>
                      </el-checkbox-group>
                  </el-row>
                </el-form-item>
              </el-form>
              <el-row>
                <el-button @click="clickNextOfGeneralSection" style="margin-top: 15px" size="mini" type="primary" round>{{$t('message.Next_Step')}}</el-button>
              </el-row>
            </el-collapse-item>
            <el-collapse-item :title="$t('message.Advanced')" ref="advancedSection">
              <el-tabs type="border-card" stretch>
                <el-tab-pane :label="$t('message.Performance_Criterias')">
                  <el-row>
                    <el-collapse>
                      <el-collapse-item ref="audienceSection">
                        <template slot="title">
                          <div style="color: #53ADBC; font-weight: bold;">
                            {{$t('message.ByAudience')}}
                          </div>
                        </template>
                        <el-collapse class="hidden-sm-and-up sub-collapse-menu">
                          <el-collapse-item>
                            <template slot="title">
                              <div style="color: #254A6E; font-weight: bold;">
                                {{$t('message.Audience')}}
                              </div>
                            </template>
                            <el-form ref="audience_form" label-width="40%">
                              <el-form-item :label="$t('message.Gender')">
                                <el-row style="text-align: left;width: 80%; margin: 5px 20px 0 20px;">
                                  <el-select v-if ="$i18n.locale=='en'" v-model="value_gender" size="small" clearable :disabled="disable_poi_audience">
                                    <el-option v-for="item in gender_options" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                  </el-select>
                                  <el-select v-if ="$i18n.locale=='cn'" v-model="value_gender" size="small" clearable :disabled="disable_poi_audience">
                                    <el-option v-for="item in gender_options" :key="item.value" :label="item.label_cn" :value="item.value">
                                    </el-option>
                                  </el-select>
                                </el-row>
                              </el-form-item>
                              <el-form-item :label="$t('message.Age')">
                                <el-row style="text-align: left;width: 80%; margin: 5px 20px 0 20px;">
                                  <el-select v-if ="$i18n.locale=='en'" v-model="value_age" size="small" multiple :disabled="disable_poi_audience"
                                    @change="checkBoxValueAge">
                                    <el-option v-for="item in age_options" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                  </el-select>
                                  <el-select v-if ="$i18n.locale=='cn'" v-model="value_age" size="small" multiple :disabled="disable_poi_audience"
                                    @change="checkBoxValueAge">
                                    <el-option v-for="item in age_options" :key="item.value" :label="item.label_cn" :value="item.value">
                                    </el-option>
                                  </el-select>
                                </el-row>
                              </el-form-item>
                              <el-form-item :label="$t('message.Spend_Power')">
                                <el-row style="text-align: left;width: 80%; margin: 5px 20px 0 20px;">
                                  <el-select v-if ="$i18n.locale=='en'" v-model="value_spend_power" size="small" multiple :disabled="disable_poi_audience"
                                    @change="checkBoxValueSpendPower">
                                    <el-option v-for="item in display_spend_power_options" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                  </el-select>
                                  <el-select v-if ="$i18n.locale=='cn'" v-model="value_spend_power" size="small" multiple :disabled="disable_poi_audience"
                                    @change="checkBoxValueSpendPower">
                                    <el-option v-for="item in display_spend_power_options" :key="item.value" :label="item.label_cn" :value="item.value">
                                    </el-option>
                                  </el-select>
                                </el-row>
                              </el-form-item>
                            </el-form>
                          </el-collapse-item>
                          <el-collapse-item>
                            <template slot="title">
                              <div style="color: #254A6E; font-weight: bold;">
                                {{$t('message.Interests')}}
                              </div>
                            </template>
                            <el-checkbox-group v-if = "$i18n.locale == 'en'" style="text-align: left;" v-model="value_interest_temp" :disabled="disable_poi_audience" @change="handlecheckedInterest">
                              <el-checkbox style="width:100%;margin:0px 10px;" v-for="item in interest_options" :key="item.value" :label="item.value" :value="item.value">
                                {{item.label}}
                              </el-checkbox>
                            </el-checkbox-group>
                            <el-checkbox-group v-if = "$i18n.locale == 'cn'" style="text-align: left;" v-model="value_interest_temp" :disabled="disable_poi_audience" @change="handlecheckedInterest">
                              <el-checkbox style="width:100%;margin:0px 10px;" v-for="item in interest_options" :key="item.value" :label="item.value" :value="item.value">
                                {{item.label_cn}}
                              </el-checkbox>
                            </el-checkbox-group>
                          </el-collapse-item>
                        </el-collapse>

                        <el-row class="hidden-xs-only">
                          <el-col :span=12>
                            <el-card class="box-card" shadow="never">
                              <div slot="header" class="clearfix">
                                <span>{{$t('message.Audience')}}</span>
                              </div>
                              
                              <div style="min-height: 220px">
                                <el-form ref="audience_form" label-width="40%">
                                  <el-form-item :label="$t('message.Gender')">
                                    <el-row style="text-align: left;width: 80%; margin: 5px 20px 0 20px;">
                                      <el-select v-if ="$i18n.locale=='en'" v-model="value_gender" size="small" clearable :disabled="disable_poi_audience">
                                        <el-option v-for="item in gender_options" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                      </el-select>
                                      <el-select v-if ="$i18n.locale=='cn'" v-model="value_gender" size="small" clearable :disabled="disable_poi_audience">
                                        <el-option v-for="item in gender_options" :key="item.value" :label="item.label_cn" :value="item.value">
                                        </el-option>
                                      </el-select>
                                    </el-row>
                                  </el-form-item>
                                  <el-form-item :label="$t('message.Age')">
                                    <el-row style="text-align: left;width: 80%; margin: 5px 20px 0 20px;">
                                      <el-select v-if ="$i18n.locale=='en'" v-model="value_age" size="small" multiple :disabled="disable_poi_audience"
                                        @change="checkBoxValueAge">
                                        <el-option v-for="item in age_options" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                      </el-select>
                                      <el-select v-if ="$i18n.locale=='cn'" v-model="value_age" size="small" multiple :disabled="disable_poi_audience"
                                        @change="checkBoxValueAge">
                                        <el-option v-for="item in age_options" :key="item.value" :label="item.label_cn" :value="item.value">
                                        </el-option>
                                      </el-select>
                                    </el-row>
                                  </el-form-item>
                                  <el-form-item :label="$t('message.Spend_Power')">
                                    <el-row style="text-align: left;width: 80%; margin: 5px 20px 0 20px;">
                                      <el-select v-if ="$i18n.locale=='en'" v-model="value_spend_power" size="small" multiple :disabled="disable_poi_audience"
                                        @change="checkBoxValueSpendPower">
                                        <el-option v-for="item in display_spend_power_options" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                      </el-select>
                                      <el-select v-if ="$i18n.locale=='cn'" v-model="value_spend_power" size="small" multiple :disabled="disable_poi_audience"
                                        @change="checkBoxValueSpendPower">
                                        <el-option v-for="item in display_spend_power_options" :key="item.value" :label="item.label_cn" :value="item.value">
                                        </el-option>
                                      </el-select>
                                    </el-row>
                                  </el-form-item>
                                </el-form>
                              </div>
                            </el-card>
                          </el-col>
                          <el-col :span=12>
                            <el-card class="box-card" shadow="never">
                              <div slot="header" class="clearfix">
                                <span>{{$t('message.Interests')}}</span>
                              </div>

                              <div style="min-height: 220px">
                                <el-checkbox-group v-if = "$i18n.locale == 'en'" style="text-align: left;" v-model="value_interest_temp" :disabled="disable_poi_audience" @change="handlecheckedInterest">
                                  <el-checkbox style="width:100%;margin:0px 10px;" v-for="item in interest_options" :key="item.value" :label="item.value" :value="item.value">
                                    {{item.label}}
                                  </el-checkbox>
                                </el-checkbox-group>
                                <el-checkbox-group v-if = "$i18n.locale == 'cn'" style="text-align: left;" v-model="value_interest_temp" :disabled="disable_poi_audience" @change="handlecheckedInterest">
                                  <el-checkbox style="width:100%;margin:0px 10px;" v-for="item in interest_options" :key="item.value" :label="item.value" :value="item.value">
                                    {{item.label_cn}}
                                  </el-checkbox>
                                </el-checkbox-group>
                              </div>
                            </el-card>
                          </el-col>
                        </el-row>
                      </el-collapse-item>
                      <el-collapse-item ref="poiSection">
                        <template slot="title">
                          <div style="color: #53ADBC; font-weight: bold;">
                            {{$t('message.ByPointsOfInterest')}}
                          </div>
                        </template>
                        <el-collapse class="hidden-sm-and-up sub-collapse-menu">
                          <el-collapse-item>
                            <template slot="title">
                              <div style="color: #254A6E; font-weight: bold;">
                                {{$t('message.POIType')}}
                              </div>
                            </template>
                            <div style="margin:0 10px; text-align:left;">
                              <div style="margin-top:5px;">
                                <el-checkbox v-model="checked_business" :disabled="disable_poi_audience" style="width: 100%">{{ $t('message.BUSINESS') }}</el-checkbox>
                                <p style="font-size:10px; text-align: left;color:#606266;font-weight: 500;">
                                  {{ $t('message.Business_Center') }} /{{ $t('message.Industrial_Park') }} / {{ $t('message.Government') }}
                                </p>
                              </div>
                      
                              <div style="margin-top:5px;">
                                <el-checkbox v-model="checked_entertainment" :disabled="disable_poi_audience" style="width: 100%">{{ $t('message.ENTERTAINEMENT') }}</el-checkbox>
                                <p style="font-size:10px; text-align: left;color:#606266;font-weight: 500;">
                                  {{ $t('message.Sports') }} /{{ $t('message.Entertainment') }} / {{ $t('message.Culture') }}
                                </p>
                              </div>
                              <div style="margin-top:5px;">
                                <el-checkbox v-model="checked_living" :disabled="disable_poi_audience" style="width: 100%">{{ $t('message.LIVING') }}</el-checkbox>
                                <p style="font-size:10px; text-align: left;color:#606266;font-weight: 500;">
                                  {{ $t('message.Shopping') }} /{{ $t('message.Residental_Area') }} / {{ $t('message.School_University') }} / {{ $t('message.Hospital') }}
                                </p>
                              </div>
                              <div style="margin-top:5px;">
                                <el-checkbox v-model="checked_trip" :disabled="disable_poi_audience" style="width: 100%">{{ $t('message.TRIP') }}</el-checkbox>
                                <p style="font-size:10px; text-align: left;color:#606266;font-weight: 500;">
                                  {{ $t('message.Tourist_Attractions') }} / {{ $t('message.Transportation_Hub') }} / {{ $t('message.Art_Museum') }}
                                </p>
                              </div>
                            </div>
                            </el-collapse-item>
                          <el-collapse-item>
                            <template slot="title">
                              <div style="color: #254A6E; font-weight: bold;">
                                {{$t('message.POILocation')}}
                              </div>
                            </template>
                            <el-select v-model="poi_ba_selection_list" filterable size="small" multiple :multiple-limit="6" :placeholder="$t('message.Select')"
                              remote>
                              <el-option
                              v-for="item in poi_ba_options"
                                :key="item.value"
                                :label="item.label"
                                :value="{value:item.value,label:item.label}">
                              </el-option>
                            </el-select>
                          </el-collapse-item>
                        </el-collapse>

                        <el-row class="hidden-xs-only">
                          <el-col :span=12>
                            <el-card class="box-card" shadow="never">
                              <div slot="header" class="clearfix">
                                <span>{{$t('message.POIType')}}</span>
                              </div>
                              
                              <div style="min-height: 200px">
                                <div style="margin:0 10px; text-align:left;">
                                  <div>
                                    <el-checkbox v-model="checked_business" :disabled="disable_poi_audience" style="width: 100%">{{ $t('message.BUSINESS') }}</el-checkbox>
                                    <p style="font-size:10px; text-align: left;color:#606266;font-weight: 500;">
                                      {{ $t('message.Business_Center') }} /{{ $t('message.Industrial_Park') }} / {{ $t('message.Government') }}
                                    </p>
                                  </div>
                          
                                  <div style="margin-top:5px;">
                                    <el-checkbox v-model="checked_entertainment" :disabled="disable_poi_audience" style="width: 100%">{{ $t('message.ENTERTAINEMENT') }}</el-checkbox>
                                    <p style="font-size:10px; text-align: left;color:#606266;font-weight: 500;">
                                      {{ $t('message.Sports') }} /{{ $t('message.Entertainment') }} / {{ $t('message.Culture') }}
                                    </p>
                                  </div>
                                  <div style="margin-top:5px;">
                                    <el-checkbox v-model="checked_living" :disabled="disable_poi_audience" style="width: 100%">{{ $t('message.LIVING') }}</el-checkbox>
                                    <p style="font-size:10px; text-align: left;color:#606266;font-weight: 500;">
                                      {{ $t('message.Shopping') }} /{{ $t('message.Residental_Area') }} / {{ $t('message.School_University') }} / {{ $t('message.Hospital') }}
                                    </p>
                                  </div>
                                  <div style="margin-top:5px;">
                                    <el-checkbox v-model="checked_trip" :disabled="disable_poi_audience" style="width: 100%">{{ $t('message.TRIP') }}</el-checkbox>
                                    <p style="font-size:10px; text-align: left;color:#606266;font-weight: 500;">
                                      {{ $t('message.Tourist_Attractions') }} / {{ $t('message.Transportation_Hub') }} / {{ $t('message.Art_Museum') }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </el-card>
                          </el-col>
                          <el-col :span=12>
                            <el-card class="box-card" shadow="never">
                              <div slot="header" class="clearfix">
                                <span>{{$t('message.POILocation')}}</span>
                              </div>

                              <div style="min-height: 200px">
                                <el-select v-model="poi_ba_selection_list" filterable size="small" multiple :multiple-limit="6" :placeholder="$t('message.Select')"
                                  remote style="margin-top: 40px">
                                  <el-option
                                  v-for="item in poi_ba_options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="{value:item.value,label:item.label}">
                                  </el-option>
                                </el-select>
                              </div>
                            </el-card>
                          </el-col>
                        </el-row>
                      </el-collapse-item>
                    </el-collapse>
                    <el-row>
                      <el-button @click="goNext" style="margin-top: 15px" size="mini" type="primary" round>{{$t('message.Done')}}</el-button>
                    </el-row>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane :label="$t('message.RegularRateCard')">
                  <el-row>
                    <el-col :span=24>
                      <span class="title-3" style="margin:10px;color:#254A6E;font-weight:600">{{$t('message.Rank')}}
                        <el-popover placement="top-start" width="200" trigger="click">
                          <div style="word-break: break-word; text-align: left;">
                            <span>{{$t('message.LegacyFixedSystem')}}</span>
                          </div>
                          <el-button icon="el-icon-info" circle slot="reference" style="border:0px"></el-button>
                        </el-popover>
                      </span>
                    </el-col>
                    <el-col :span=24>
                      <el-checkbox-group v-model="value_rank" style="text-align: left;">
                        <el-checkbox v-for="item in rank_options" :label="item.value" :key="item.value" style="display:block; margin-top: 10px; margin-left: 40%;">
                          {{item.label}}
                        </el-checkbox>
                      </el-checkbox-group>
                      <el-row style="margin-top: 10px">
                        <el-button @click="goNext" style="margin-top: 15px" size="mini" type="primary" round>{{$t('message.Done')}}</el-button>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </el-main>
  </el-container>

</template>
<script>
import head_page from "./components/head_page.vue";
import head_menu from "./components/head_menu.vue";
import axios from "axios";
import _global from "./components/global.vue";
let tmp = new Date()
let date_now = tmp.setMonth(tmp.getMonth()+2)
export default {
  name: "information",
  data() {
    return {
      timeOffset: (new Date()).getTimezoneOffset() * 60000,
      activeName: "first",
      gender_options: [],
      age_options: [],
      spend_power_options: [],
      interest_options: [],

      checked_business: false,
      checked_entertainment: false,
      checked_living: false,
      checked_trip: false,

      media_format_options: [],
      vendor_options:[],
      rank_options: [],

      value_gender: 0,
      value_age: [0],
      value_spend_power: [0],
      //value_interest: 0,
      value_interest_temp: [0],
      value_media_format: [2],
      value_rank: [],
      audience_info: [],
      chosen_city: "",
      lang: "en",
      loading: true,
      pickerOptions: [],
      value1: "",
      estimated_audience: 0,
      value_duration: 1,
      value_vendor:[],
      disable_poi_audience: false,
      dataValueBadge: 0,
      poi_ba_options: [],
      poi_ba_selection_list: "",
      checkboxGroup1: ["上海"],
      cities: ["上海", "北京", "广州", "深圳"],
      value_date: date_now,
      //isDirector:false,
      create_package :false,
      menuFixed: false,
      disableNext: false,
      show_vendor_box_city : ['Shanghai','Chongqing','Shenzhen','Chengdu']
    };
  },
  computed: {
    // value_date: function(val){
    //   let date = new Date()
    //   date.setMonth(date.getMonth()+2)
    //   return date
    // },
    version(){
      let version =''
      if (this.$route.query.chosen_city == "Nanjing"){
        version = '@v'+_global.VERSION_NANJING
      }else if (this.$route.query.chosen_city == "Wuhan"){
        version = '@v'+_global.VERSION_WUHAN
      }
      return version
      
    },

    value_interest: function () {
      return this.value_interest_temp[0];
    },
    options_duration: function () {
      let options = [];
      for (let i = 1; i < 21; i++) {
        options.push({
          value: i,
          label: i,
        });
      }
      return options;
    },
    summary_value: function () {
      return {
        checked_business: this.checked_business,
        checked_entertainment: this.checked_entertainment,
        checked_living: this.checked_living,
        checked_trip: this.checked_trip,
        value_media_format: this.value_media_format,
        value_rank: this.value_rank,

        value_gender: this.value_gender,
        value_age: this.value_age,
        value_spend_power: this.value_spend_power,
        value_interest: this.value_interest,
        value_duration: this.value_duration,
        value_vendor: this.value_vendor,
        //value_date: this.value_date,
        value_date: (new Date(this.value_date)).toISOString(),

      };
    },
    chosen_city_shown: function () {
      let tmp = "message." + this.$route.query.chosen_city;
      return this.$t(tmp);
    },
    offsetTop() {
      return document.querySelector('#menu').offsetTop;
    },
    display_spend_power_options() {
    
     
        return this.spend_power_options.filter(o=> o.value != 2 && o.value != 8)
     
    }
  },
  watch: {
    summary_value: function (val) {
      this.getEstimateData();
    },
    value_vendor:function(val){
      this.getMediaInfo()
    },
    value_rank: function (val) {
      // 移除禁用其他选项的逻辑，保持与其他选项的联动
      this.disable_poi_audience = false;
    },
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);//监听滑动事件
  },
  mounted() {
    this.$refs.generalSection.handleHeaderClick();
    //this.$refs.audienceSection.handleHeaderClick();
    //this.$refs.poiSection.handleHeaderClick();
    this.getPageAuthority()
    this.lang = JSON.parse(sessionStorage.getItem("lang"));
    this.$i18n.locale = this.lang;
    this.$refs.head_page.switchLang(this.lang);
    this.getReportLength();
    this.getPOISelectionList();
    this.getAudienceInfo();
    this.getVendorInfo();
    this.chosen_city = this.$route.query.chosen_city;
    this.$refs.head_page.update_user_name();
    let date_information = JSON.parse(
      sessionStorage.getItem('Data_Information')
    );
    if (date_information) {
      this.value_gender = date_information.data_audience.value_gender;
      this.value_age = date_information.data_audience.value_age;
      this.value_spend_power = date_information.data_audience.value_spend_power;
      this.value_interest_temp = [
        date_information.data_audience.value_interest,
      ];
      this.value_media_format =
        date_information.data_media_rank.value_media_format;
      this.value_rank = date_information.data_media_rank.value_rank;
      this.value_date = new Date(date_information.date).getTime();
      
      this.value_duration = date_information.value_duration;
      if (this.value_date == null) {
        this.value_date = date_information.campaignDate * 1000;
      }
      if (this.value_duration == null) {
        this.value_duration = date_information.campaignDuration;
      }
      this.value_vendor == date_information.value_vendor
      this.checked_business = date_information.data_poi.checked_business;
      this.checked_entertainment =
        date_information.data_poi.checked_entertainment;
      this.checked_living = date_information.data_poi.checked_living;
      this.checked_trip = date_information.data_poi.checked_trip;
      // return poi selection from history
      let poi_ba_value = {};
      for (let index in date_information.poi_ba_value_selection_list) {
        poi_ba_value = {
          value: date_information.poi_ba_value_selection_list[index],
          label: date_information.poi_ba_label_selection_list[index],
        };
        this.poi_ba_selection_list.push(poi_ba_value);
      }
    }
    this.getEstimateData();
  },

  methods: {
    getPageAuthority(){
        if (JSON.parse(sessionStorage.getItem('UserAuthority')) != null) {
        let userAuthority = JSON.parse(sessionStorage.getItem('UserAuthority'));
        this.create_package = userAuthority['create_package']
        // this.isAll = userAuthority['isAll']
        // this.isNanjing = userAuthority['isNanjing']
        // this.isWuhan= userAuthority['isWuhan']
      }
      },
    getReportLength() {
      let api_url = _global.serverSrc + "/report_length/" + "?format=json";
      let obj = new Object();
      obj.email = JSON.parse(sessionStorage.getItem("User"));
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          if (response.data.report_length) {
            this.dataValueBadge = response.data.report_length[0].report_number;
          }
        })
        .catch(function (error) {});
    },
    open4() {
      var _self = this;
      this.$notify({
        title: _self.$t("message.Info"),
        message: _self.$t("message.The_data_is_based_on_your_ranking"),
        position: "top-left",
      });
    },
    getEstimateData(data) {
      this.disableNext = true
      let api_url = _global.serverSrc + "/estimate_audience/?format=json&chosen_city=" + this.$route.query.chosen_city;
      var _self = this;
      if (this.summary_value["value_media_format"].length == 0) {
        this.summary_value["value_media_format"] = [1, 2]
      }
      else if (this.summary_value["value_media_format"].length > 1) {
        this.estimated_audience = "loading...";
        return ;
      }
      sessionStorage.setItem("summary_value", JSON.stringify(this.summary_value));
      let obj = {
        'email': JSON.parse(sessionStorage.getItem('User')),
        'summary_value':  this.summary_value,
      }
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          _self.estimated_audience = response.data.estimate_audience[0]["estimate_audience"];
          _self.loading = false;
          if (_self.estimated_audience && _self.estimated_audience>0) {
            this.disableNext = false
          }
        })
        .catch((e) => {
          _self.loading = false;
        });
    },
    getPOISelectionList() {
      let api_url = _global.serverSrc + "/poi_ba_list/?format=json&chosen_city=" + this.$route.query.chosen_city;
      let obj = {'email': JSON.parse(sessionStorage.getItem("User"))};
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          let poi_ba_option = {};
          for (let ele in response.data.poi_ba_list) {
            poi_ba_option = {};
            poi_ba_option.value = response.data.poi_ba_list[ele]["poi_ba_id"];
            poi_ba_option.label = response.data.poi_ba_list[ele]["poi_ba_name"];
            this.poi_ba_options.push(poi_ba_option);
          }
        })
        .catch((e) => {
        });
    },

    handlechecked: function (event) {
      if (this.value_media_format.length >= 2) this.value_media_format.shift();
    },
    handlecheckedInterest: function () {
      if (this.value_interest_temp.length > 1) {
        this.value_interest_temp.shift();
      }
    },

    goHome: function () {
      this.$router.push({
        path: "/choose_city",
      });
      let lang = JSON.parse(sessionStorage.getItem("lang"));
      let user = JSON.parse(sessionStorage.getItem("User"));
      let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
      sessionStorage.clear();
      sessionStorage.setItem("lang", JSON.stringify(lang));
      sessionStorage.setItem("User", JSON.stringify(user));
      sessionStorage.setItem("UserAuthority", JSON.stringify(UserAuthority));
    },

    backToCity: function (event) {
      this.$router.push({
        path: "/choose_city",
      });
    },

    goNext: function (event) {
      if (this.disableNext) {
        return
      }
      var _self = this;
      if (this.value_gender == null) {
        this.value_gender = 0;
      }

      if (this.value_age == null) {
        this.value_age = [0];
      }
      if (this.value_spend_power == null) {
        this.value_spend_power = [0];
      }
      if (this.value_interest == null) {
        this.value_interest_temp = [0];
      }
      if (this.value_media_format == null) {
        this.value_media_format = [1, 2];
      }
      if (this.value_rank == null) {
        this.value_rank = [1];
      }
      let data_audience = {
        value_gender: _self.value_gender,
        value_age: _self.value_age,
        value_spend_power: _self.value_spend_power,
        value_interest: _self.value_interest,
      };

      let data_poi = {
        checked_business: _self.checked_business,
        checked_entertainment: _self.checked_entertainment,
        checked_living: _self.checked_living,
        checked_trip: _self.checked_trip,
      };
      if (_self.value_media_format.length == 0) {
        _self.$notify({
          message: _self.$t("message.You_must_select_one_media_format"),
          position: "top-left",
        });
        return;
      }
      let data_media_rank = {
        value_media_format: _self.value_media_format,
        value_rank: _self.value_rank,
        value_vendor:_self.value_vendor,
      };

      // Only send poi id (not poi name) to backend
      let poi_ba_value_selection_list = [];
      let poi_ba_label_selection_list = [];
      for (let index in this.poi_ba_selection_list) {
        let value = this.poi_ba_selection_list[index].value;
        let label = this.poi_ba_selection_list[index].label;
        poi_ba_value_selection_list.push(value);
        poi_ba_label_selection_list.push(label);
      }
      let dataNext = {
        data_audience: data_audience,
        data_poi: data_poi,
        data_media_rank: data_media_rank,
        media_format_options: _self.media_format_options,
        date: new Date(new Date(_self.value_date) - _self.timeOffset).toISOString(),
        value_duration: _self.value_duration,
        poi_ba_value_selection_list: poi_ba_value_selection_list,
        poi_ba_label_selection_list: poi_ba_label_selection_list,
      };

      let audience_options = {
        gender_options: _self.gender_options,
        age_options: _self.age_options,
        spend_power_options: _self.spend_power_options,
        interest_options: _self.interest_options,
      };

      let poi_options = {
        checked_business: _self.checked_business,
        checked_entertainment: _self.checked_entertainment,
        checked_living: _self.checked_living,
        checked_trip: _self.checked_trip,
      };

      let media_rank_options = {
        media_format_options: _self.media_format_options,
        rank_options: _self.rank_options,
      };
      let options = {
        audience_options: audience_options,
        poi_options: poi_options,
        media_rank_options: media_rank_options,
        poi_ba_label_selection_list: poi_ba_label_selection_list,
      };
      let tmp = JSON.parse(sessionStorage.getItem('Data_Information'));
      if (tmp != null) {
        if (tmp.isEdit == 1) {
          dataNext.isEdit = 1;
        }
      }
      sessionStorage.setItem('Data_Information', JSON.stringify(dataNext));
      sessionStorage.setItem('Data_Options', JSON.stringify(options));

      sessionStorage.removeItem('Data_History');
      sessionStorage.removeItem('tableDataCommercial')
      sessionStorage.removeItem('Data_Map')
      this.$router.push({
        path: "/map",
        query: {
          chosen_city: this.$route.query.chosen_city,
        },
      });
    },

    checkBoxValueAge: function ($event) {
      if ($event[$event.length - 1] == 0) {
        this.value_age = [0];
      }
      if (this.value_age.length > 1) {
        //用户点了啥
        for (let ele in this.value_age) {
          if (this.value_age[ele] == 0) {
            this.value_age.splice(ele, 1);
          }
        }
      }
    },
    goPackageSelection: function(event) {
      if (this.disableNext) {
        return
      }
      var _self = this;
      if (this.value_gender == null) {
        this.value_gender = 0;
      }

      if (this.value_age == null) {
        this.value_age = [0];
      }
      if (this.value_spend_power == null) {
        this.value_spend_power = [0];
      }
      if (this.value_interest == null) {
        this.value_interest_temp = [0];
      }
      if (this.value_media_format == null) {
        this.value_media_format = [1, 2];
      }
      if (this.value_rank == null) {
        this.value_rank = [1];
      }
      if (this.value_date == null) {
        this.value_date = new Date().getTime();
      }
      let data_audience = {
        "value_gender": _self.value_gender,
        "value_age": _self.value_age,
        "value_spend_power": _self.value_spend_power,
        "value_interest": _self.value_interest
      };

      let data_poi = {
        "checked_business": _self.checked_business,
        "checked_entertainment": _self.checked_entertainment,
        "checked_living": _self.checked_living,
        "checked_trip": _self.checked_trip
      };
      if (_self.value_media_format.length == 0){
        _self.$notify({
          message: _self.$t('message.You_must_select_one_media_format'),
          position: 'top-left'
        })
        return
      }
      let data_media_rank = {
        "value_media_format": _self.value_media_format,
        "value_rank": _self.value_rank,
        "value_vendor":_self.value_vendor,
      }

      // Only send poi id (not poi name) to backend
      let poi_ba_value_selection_list = []
      let poi_ba_label_selection_list = []
      for (let index in this.poi_ba_selection_list){
        let value = this.poi_ba_selection_list[index].value
        let label = this.poi_ba_selection_list[index].label
        poi_ba_value_selection_list.push(value)
        poi_ba_label_selection_list.push(label)
      }
      let dataNext = {
        "data_audience": data_audience,
        "data_poi": data_poi,
        "data_media_rank": data_media_rank,
        "media_format_options": _self.media_format_options,
        //"date": _self.value_date,
        date: (new Date(_self.value_date)).toISOString(),
        'value_duration': _self.value_duration,
        'poi_ba_value_selection_list':poi_ba_value_selection_list,
        'poi_ba_label_selection_list':poi_ba_label_selection_list
      }

      let audience_options = {
        'gender_options': _self.gender_options,
        'age_options': _self.age_options,
        'spend_power_options': _self.spend_power_options,
        'interest_options': _self.interest_options,
      }

      let poi_options = {
        'checked_business': _self.checked_business,
        'checked_entertainment': _self.checked_entertainment,
        'checked_living': _self.checked_living,
        'checked_trip': _self.checked_trip,
      }

      let media_rank_options = {
        'media_format_options': _self.media_format_options,
        'rank_options': _self.rank_options,
      }
      let options = {
        'audience_options': audience_options,
        'poi_options': poi_options,
        'media_rank_options': media_rank_options,
        'poi_ba_label_selection_list': poi_ba_label_selection_list
      }
      let tmp = JSON.parse(sessionStorage.getItem('Data_Information'))
      if (tmp !=null){
        if (tmp.isEdit == 1){
          dataNext.isEdit = 1
        }
      }
      this.$store.state.package.Data_Information = dataNext;
      this.$store.state.package.Data_Options = options;
      sessionStorage.setItem('Data_Information', JSON.stringify(dataNext));
      sessionStorage.setItem('Data_Options', JSON.stringify(options));

      sessionStorage.removeItem('Data_History')
      this.$router.push({
        path: '/package_selection',
        query: {
          chosen_city: this.$route.query.chosen_city
        }
      })
    },

    checkBoxValueSpendPower: function ($event) {
      if ($event[$event.length - 1] == 0) {
        this.value_spend_power = [0];
      }
      if (this.value_spend_power.length > 1) {
        //用户点了啥
        for (let ele in this.value_spend_power) {
          if (this.value_spend_power[ele] == 0) {
            this.value_spend_power.splice(ele, 1);
          }
        }
      }
    },
    

    setDataFromDB_audience_info(_self, arr, lang) {
      for (let ele in arr) {
        if (_self.audience_info[ele].content === "gender") {
          _self.gender_options.push({
            value: _self.audience_info[ele].code,
            label: _self.audience_info[ele].label,
            label_cn: _self.audience_info[ele].label_cn,
          });
        } else if (_self.audience_info[ele].content === "age") {
          _self.age_options.push({
            value: _self.audience_info[ele].code,
            label: _self.audience_info[ele].label,
            label_cn: _self.audience_info[ele].label_cn,
          });
        } else if (_self.audience_info[ele].content === "spend power") {
          _self.spend_power_options.push({
            value: _self.audience_info[ele].code,
            label: _self.audience_info[ele].label,
            label_cn: _self.audience_info[ele].label_cn,
          });
        } else if (_self.audience_info[ele].content === "interest") {
          _self.interest_options.push({
            value: _self.audience_info[ele].code,
            label: _self.audience_info[ele].label,
            label_cn: _self.audience_info[ele].label_cn,
          });
        }
      }
    },
    getAudienceInfo() {
      let api_url = _global.serverSrc + "/audience_info/?format=json&chosen_city=" + this.$route.query.chosen_city;
      let obj = {'email': JSON.parse(sessionStorage.getItem('User')),'date':this.value_date}
      var _self = this;
      this.$axios
        .post(api_url, obj)
        .then(function (response) {
          if (response.data) {
            _self.audience_info = response.data.audience_info;
            //初始化
            _self.gender_options = [];
            _self.age_options = [];
            _self.spend_power_options = [];
            _self.interest_options = [];

            _self.setDataFromDB_audience_info(
              _self,
              _self.audience_info,
              _self.$i18n.locale
            );

            _self.sortOptionsByValue(_self.gender_options);
            _self.sortOptionsByValue(_self.age_options);
            _self.sortOptionsByValue(_self.spend_power_options);
            _self.sortOptionsByValue(_self.interest_options);
            if (_self.interest_options.length == 10) {
              for (let ele in _self.interest_options) {
                if (_self.interest_options[ele].value == 1) {
                  _self.interest_options.splice(1, 1);
                }
              }
            }
          }
        })
        .catch(function (error) {
        });
    },
    setDataFromDB_media_info(_self, arr, lang) {
      for (let ele in arr) {
        if (arr[ele].content == "media format") {
          _self.media_format_options.push({
            value: arr[ele].code,
            label: arr[ele].label,
            label_cn: arr[ele].label_cn,
          });
          _self.value_media_format = [_self.media_format_options[0].value] // default value
        } else if (arr[ele].content == "rank") {
          _self.rank_options.push({
            value: arr[ele].code,
            label: arr[ele].label,
            label_cn: arr[ele].label_cn,
          });
        } else if (arr[ele].content == "vendor") {
          _self.vendor_options.push({
            value: arr[ele].code,
            label: arr[ele].label,
            label_cn: arr[ele].label_cn,
          });
          _self.value_vendor = [_self.vendor_options[0].value] // default value
        }
      }
      if (this.$route.query.chosen_city == "Shenzhen" || this.$route.query.chosen_city == "Chongqing" || this.$route.query.chosen_city == "Chengdu"){
        this.media_format_options.reverse()
        this.value_media_format = [this.media_format_options[0].value]
      }
    },
    getMediaInfo() {
      let api_url = _global.serverSrc + "/media_info/?format=json&chosen_city=" + this.$route.query.chosen_city;
      let obj = {'email': JSON.parse(sessionStorage.getItem('User')),'date':this.value_date,'value_vendor':this.value_vendor}
      var _self = this;
      this.$axios
        .post(api_url, obj) 
        .then((response) => {
          if (response.data) {
            _self.media_format_options = [];
            _self.rank_options = [];
            _self.setDataFromDB_media_info(
              _self,
              response.data.media_info,
              _self.$i18n.locale
            );
          }
        })
        .catch(function (error) {
        });
    },
    async getVendorInfo(){
      let api_url = _global.serverSrc + "/vendor_info/?format=json&chosen_city=" + this.$route.query.chosen_city;
      let obj = {'email': JSON.parse(sessionStorage.getItem('User')),'date':this.value_date}
      var _self = this;
      this.$axios
        .post(api_url, obj) 
        .then((response) => {
          if (response.data) {
            // _self.vendor_options = [];
            _self.setDataFromDB_media_info(
              _self,
              response.data.vendor_info,
              _self.$i18n.locale
            );
            _self.getMediaInfo()
          }
        })
        .catch(function (error) {
        });
    },
    sortOptionsByValue: function (options) {
      var i = options.length,
        j;
      var tempExchangVal;
      while (i > 0) {
        for (j = 0; j < i - 1; j++) {
          if (options[j].value > options[j + 1].value) {
            tempExchangVal = options[j];
            options[j] = options[j + 1];
            options[j + 1] = tempExchangVal;
          }
        }
        i--;
      }
    },
    goHistory() {
      this.$router.push("./history");
    },
    handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > this.offsetTop) {
        this.menuFixed = true
      } else {
        this.menuFixed = false
      }
    },
    clickNextOfGeneralSection() {
      this.$refs.advancedSection.handleHeaderClick();
    }
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);//监听滑动事件
  },
  components: {
    head_page,
    head_menu
  },
};
</script>
<style lang="scss" scoped>
  .el-row {
    &:last-child {
      margin-bottom: 0;
    }
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .bg-white {
    background: white;
  }
  .bg-grey {
    background-color: #f6f6f6;
  }

  /deep/ .el-checkbox {
    @media (min-width: 1200px) {
      margin-bottom: 0.5rem;
    }
    @media (min-width: 992px) and (max-width: 1199px) {
      margin-bottom: 0;
    }
    @media (max-width: 991px) {
       margin-bottom: 0;
       margin-right: 0;
    }
  }

  /deep/ .el-checkbox-button__inner {
    font-size: 12px;

    @media (min-width: 992px) and (max-width: 1199px) {
      padding: 14px 5px;
    }
  }

  /deep/ .el-checkbox__label {
    word-break: normal;
    display: inline-grid;
    white-space: pre-line;
    word-wrap: break-word;
    overflow: hidden;
    line-height: 1.5;
    @media (min-width: 1200px) {
      font-size: 14px;
      width: calc(100% - 30px);
      margin: 0 5px;
    }
    @media (min-width: 992px) and (max-width: 1199px) {
      font-size: 12px;
      width: calc(100% - 30px);
      margin: 0 5px;
    } 
    @media (max-width: 991px) {
      font-size: 12px;
      width: 100%;
      padding-right: 20px;
      margin: 0 5px;
    }
  }

  /deep/ .el-form-item__content {
    @media (max-width: 991px) {
      line-height:30px;
    }
  }

  /deep/ .el-button.is-circle {
    padding: 6px 6px;
    margin-bottom: 6px;
  }

  .title-3 {
    @media (min-width: 1200px) {
      font-size: 20px;
    }
    @media (min-width: 992px) and (max-width: 1199px) {
      font-size: 16px;
    }
  }

  .isFixed{
    @media (max-width:767px) {
      position:fixed;
      width: calc(100% - 40px);
      margin:0 20px;
      top: 40px;
      left: 0;
      z-index:999;
    }
  }

  /deep/ .el-form-item__label {
    font-size: 12px;
  }

  /deep/ .el-form-item {
    margin-bottom: 0;
  }

  /deep/ .el-collapse-item__content {
    padding-bottom: 10px;
  }

  /deep/ #choose_city .el-tabs__header .el-tabs__item.is-active {
    background-color: #409EFF;
  }

  .sub-collapse-menu /deep/ .el-collapse-item__header{
    margin: 0 10px;
    height: 38px;
  }

  .p_navi_button_disabled {
    color: rgba(83, 173, 188, 0.5);
    cursor: not-allowed;
    border: 1px solid rgba(37, 74, 110, 0.5);
    background: #f7f7f7;
    font-size: 25px;
  }

  /deep/ .el-checkbox-button__inner {
    border: 1px solid #DCDFE6!important;
    border-radius: 4px!important;
  }

</style>
